import { Box, CircularProgress, TextField, Typography } from "@mui/material";
import { Styled } from "../styles";
import CachedIcon from "@mui/icons-material/Cached";
import { i18n } from "@/utils/i18n";

interface Props {
    search: string;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
    refetch: () => void;
    isLoading: boolean;
    isFetching: boolean;
    title: string;
    total: number;
    rows: Array<{ id: string }>;
}

const Header: React.FC<Props> = ({
    search,
    setSearch,
    refetch,
    isLoading,
    isFetching,
    title,
    total,
    rows,
}) => {
    return (
        <Styled.Header>
            <Box>
                <Typography variant="h6" fontWeight="semibold">
                    {title}
                </Typography>
                <Typography variant="body2" sx={{ color: "grey.600" }}>
                    {total || rows.length} {i18n.t("result")}
                </Typography>
            </Box>
            <Box display="flex" gap="2" alignItems="center">
                {isFetching && (
                    <Box display="flex" alignItems="center" gap={1}>
                        <CircularProgress size={14} />
                        <Typography variant="caption" sx={{ color: "grey.700", fontSize: "12px" }}>
                            Laddar sida...
                        </Typography>
                    </Box>
                )}
                <Styled.SearchContainer>
                    <TextField
                        size="small"
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        label={i18n.t("label.search")}
                        placeholder={i18n.t("placeholder.search")}
                        fullWidth
                        variant="outlined"
                    />
                </Styled.SearchContainer>
                <Styled.IconButton
                    onClick={() => refetch()}
                    disabled={isLoading}
                    aria-label="Reload data"
                    size="small"
                >
                    <Styled.SpinningIcon loading={isLoading ? 1 : 0}>
                        <CachedIcon />
                    </Styled.SpinningIcon>
                </Styled.IconButton>
            </Box>
        </Styled.Header>
    );
};

export default Header;
